// extracted by mini-css-extract-plugin
export var container = "Modal-module--container--8bdcb";
export var content = "Modal-module--content--02c91";
export var footer = "Modal-module--footer--3a94b";
export var footerCenter = "Modal-module--footer-center--5181e";
export var footerSpace = "Modal-module--footer-space--eb560";
export var header = "Modal-module--header--8e8cc";
export var htmlBody = "Modal-module--html-body--9bd1a";
export var overlay = "Modal-module--overlay--7fb17";
export var window = "Modal-module--window--e5538";
export var windowLayoutDefault = "Modal-module--window--layout-default--46421";
export var windowLayoutNarrow = "Modal-module--window--layout-narrow--0c505";
export var windowWithFooter = "Modal-module--window--with-footer--c9870";